/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountingConfigDto,
  AccountingConfigField,
  AccountingConnectionDto,
  AccountingIntegrationDetailsDto,
  AccountingWalletConfigDto,
  AuthorizeOrganisationRequest,
  AvailableDMSPlatform,
  AvailablePlatform,
  BatchExportStatusResponse,
  BulkFieldsConfigurationUpdateRequest,
  CommonPreExportSummaryDto,
  CreateAccountingConnectionPayload,
  DmsConnectionDto,
  DmsConnectionRequest,
  FieldsConfigurationDto,
  FieldsConfigurationUpdateRequest,
  FindPlatformDimensionByNamePrefixParams,
  GetAllAvailableDmsPlatformsParams,
  GetFileCabinetsParams,
  GetSupplierAccountsByNamePrefixParams,
  InitiateBatchExportRequest,
  InitiateBatchExportResponse,
  InitiateCheckConnectionRequest,
  InitiateResourceImportRequest,
  OrganisationAccountingDto,
  PagedResponsePlatformAccountingYearDetailDto,
  PagedResponsePlatformDimensionDto,
  PagedResponsePlatformFileCabinetDto,
  PagedResponsePlatformObjectDto,
  PagedResponsePlatformOrganisationDto,
  PagedResponseSupplierAccountDto,
  Persona,
  PlatformConnectionCheckDto,
  PlatformDimensionDto,
  PlatformObjectSearchRequest,
  PlatformSyncDataDto,
  PreValidateRequest,
  SearchLastExportStatusRequest,
  SearchLastExportStatusResponse,
  SpendType,
  UpdateAccountingConfigurationRequestDto,
  UpdateFileCabinetRequestDto,
  UpdateVatDisabledRequestDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiOrganisationAccountingController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetOrganisationAccounting
   * @request GET:/api/v1/organisation-accounting
   */
  getOrganisationAccounting = (params: RequestParams = {}) =>
    this.http.request<OrganisationAccountingDto, any>({
      path: `/v1/organisation-accounting`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationAccountingPath = '/v1/organisation-accounting'
  static getOrganisationAccountingMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateOrganisationAccounting
   * @request PUT:/api/v1/organisation-accounting
   */
  updateOrganisationAccounting = (data: OrganisationAccountingDto, params: RequestParams = {}) =>
    this.http.request<OrganisationAccountingDto, any>({
      path: `/v1/organisation-accounting`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateOrganisationAccountingPath = '/v1/organisation-accounting'
  static updateOrganisationAccountingMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetPersonaFieldsConfiguration
   * @request GET:/api/v1/organisation-accounting/field-configurations/{spendType}/{persona}/fields
   */
  getPersonaFieldsConfiguration = (
    spendType: SpendType,
    persona: Persona,
    params: RequestParams = {},
  ) =>
    this.http.request<FieldsConfigurationDto, any>({
      path: `/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPersonaFieldsConfigurationPath =
    '/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields'
  static getPersonaFieldsConfigurationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateFieldsConfigurationForSpendTypeAndPersona
   * @request PUT:/api/v1/organisation-accounting/field-configurations/{spendType}/{persona}/fields
   */
  updateFieldsConfigurationForSpendTypeAndPersona = (
    spendType: SpendType,
    persona: Persona,
    data: FieldsConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<FieldsConfigurationDto, any>({
      path: `/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFieldsConfigurationForSpendTypeAndPersonaPath =
    '/v1/organisation-accounting/field-configurations/${spendType}/${persona}/fields'
  static updateFieldsConfigurationForSpendTypeAndPersonaMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name BulkUpdateFieldsConfigurationForSpendTypeAndPersona
   * @request PUT:/api/v1/organisation-accounting/field-configurations/{spendType}/{persona}/bulk-fields
   */
  bulkUpdateFieldsConfigurationForSpendTypeAndPersona = (
    spendType: SpendType,
    persona: Persona,
    data: BulkFieldsConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<FieldsConfigurationDto, any>({
      path: `/v1/organisation-accounting/field-configurations/${spendType}/${persona}/bulk-fields`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateFieldsConfigurationForSpendTypeAndPersonaPath =
    '/v1/organisation-accounting/field-configurations/${spendType}/${persona}/bulk-fields'
  static bulkUpdateFieldsConfigurationForSpendTypeAndPersonaMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetFieldsConfiguration
   * @request GET:/api/v1/organisation-accounting/field-configurations/{spendType}/fields
   * @deprecated
   */
  getFieldsConfiguration = (spendType: SpendType, params: RequestParams = {}) =>
    this.http.request<FieldsConfigurationDto, any>({
      path: `/v1/organisation-accounting/field-configurations/${spendType}/fields`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getFieldsConfigurationPath =
    '/v1/organisation-accounting/field-configurations/${spendType}/fields'
  static getFieldsConfigurationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateFieldsConfiguration
   * @request PUT:/api/v1/organisation-accounting/field-configurations/{spendType}/fields
   */
  updateFieldsConfiguration = (
    spendType: SpendType,
    data: FieldsConfigurationUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<FieldsConfigurationDto, any>({
      path: `/v1/organisation-accounting/field-configurations/${spendType}/fields`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFieldsConfigurationPath =
    '/v1/organisation-accounting/field-configurations/${spendType}/fields'
  static updateFieldsConfigurationMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateVatDisabled
   * @request PUT:/api/v1/organisation-accounting/connection/{connectionId}/accountingConfiguration/vatDisabled
   */
  updateVatDisabled = (
    connectionId: string,
    data: UpdateVatDisabledRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountingConfigDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/vatDisabled`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateVatDisabledPath =
    '/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/vatDisabled'
  static updateVatDisabledMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateFileCabinet
   * @request PUT:/api/v1/organisation-accounting/connection/{connectionId}/accountingConfiguration/fileCabinet
   */
  updateFileCabinet = (
    connectionId: string,
    data: UpdateFileCabinetRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountingConfigDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/fileCabinet`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateFileCabinetPath =
    '/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration/fileCabinet'
  static updateFileCabinetMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAccountingWalletConfig
   * @request GET:/api/v1/organisation-accounting/accounting-configuration/wallets
   */
  getAccountingWalletConfig = (params: RequestParams = {}) =>
    this.http.request<AccountingWalletConfigDto[], any>({
      path: `/v1/organisation-accounting/accounting-configuration/wallets`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingWalletConfigPath =
    '/v1/organisation-accounting/accounting-configuration/wallets'
  static getAccountingWalletConfigMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name UpdateAccountingWalletConfig
   * @request PUT:/api/v1/organisation-accounting/accounting-configuration/wallets
   */
  updateAccountingWalletConfig = (data: AccountingWalletConfigDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/accounting-configuration/wallets`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateAccountingWalletConfigPath =
    '/v1/organisation-accounting/accounting-configuration/wallets'
  static updateAccountingWalletConfigMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name CreateAccountingWalletConfig
   * @request POST:/api/v1/organisation-accounting/accounting-configuration/wallets
   */
  createAccountingWalletConfig = (data: AccountingWalletConfigDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/accounting-configuration/wallets`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createAccountingWalletConfigPath =
    '/v1/organisation-accounting/accounting-configuration/wallets'
  static createAccountingWalletConfigMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name InitiateResourceImport
   * @request POST:/api/v1/organisation-accounting/settings/resource/import
   */
  initiateResourceImport = (data: InitiateResourceImportRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/settings/resource/import`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static initiateResourceImportPath = '/v1/organisation-accounting/settings/resource/import'
  static initiateResourceImportMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name SearchPlatformObjects
   * @request POST:/api/v1/organisation-accounting/platform-objects/search
   */
  searchPlatformObjects = (data: PlatformObjectSearchRequest, params: RequestParams = {}) =>
    this.http.request<PagedResponsePlatformObjectDto, any>({
      path: `/v1/organisation-accounting/platform-objects/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static searchPlatformObjectsPath = '/v1/organisation-accounting/platform-objects/search'
  static searchPlatformObjectsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name PreValidate
   * @request POST:/api/v1/organisation-accounting/export/pre-validate
   */
  preValidate = (data: PreValidateRequest, params: RequestParams = {}) =>
    this.http.request<CommonPreExportSummaryDto, any>({
      path: `/v1/organisation-accounting/export/pre-validate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static preValidatePath = '/v1/organisation-accounting/export/pre-validate'
  static preValidateMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetLastExportStatuses
   * @request POST:/api/v1/organisation-accounting/export/exports/last-status
   */
  getLastExportStatuses = (data: SearchLastExportStatusRequest, params: RequestParams = {}) =>
    this.http.request<SearchLastExportStatusResponse, any>({
      path: `/v1/organisation-accounting/export/exports/last-status`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getLastExportStatusesPath = '/v1/organisation-accounting/export/exports/last-status'
  static getLastExportStatusesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name BatchExport
   * @request POST:/api/v1/organisation-accounting/export/batch-exports
   */
  batchExport = (data: InitiateBatchExportRequest, params: RequestParams = {}) =>
    this.http.request<InitiateBatchExportResponse, any>({
      path: `/v1/organisation-accounting/export/batch-exports`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static batchExportPath = '/v1/organisation-accounting/export/batch-exports'
  static batchExportMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name CreateDmsConnection
   * @request POST:/api/v1/organisation-accounting/dms-connection
   */
  createDmsConnection = (data: DmsConnectionRequest, params: RequestParams = {}) =>
    this.http.request<DmsConnectionDto, any>({
      path: `/v1/organisation-accounting/dms-connection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createDmsConnectionPath = '/v1/organisation-accounting/dms-connection'
  static createDmsConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name TestDmsConnection
   * @request POST:/api/v1/organisation-accounting/dms-connection/test-connection
   */
  testDmsConnection = (data: DmsConnectionRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/dms-connection/test-connection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static testDmsConnectionPath = '/v1/organisation-accounting/dms-connection/test-connection'
  static testDmsConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name CreateAccountingConnection
   * @request POST:/api/v1/organisation-accounting/connections
   */
  createAccountingConnection = (
    data: CreateAccountingConnectionPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountingConnectionDto, any>({
      path: `/v1/organisation-accounting/connections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createAccountingConnectionPath = '/v1/organisation-accounting/connections'
  static createAccountingConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAccountingConfigurationByConnection
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/accountingConfiguration
   */
  getAccountingConfigurationByConnection = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<AccountingConfigDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingConfigurationByConnectionPath =
    '/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration'
  static getAccountingConfigurationByConnectionMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name SaveAccountingConfiguration
   * @request POST:/api/v1/organisation-accounting/connection/{connectionId}/accountingConfiguration
   */
  saveAccountingConfiguration = (
    connectionId: string,
    data: UpdateAccountingConfigurationRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AccountingConfigDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static saveAccountingConfigurationPath =
    '/v1/organisation-accounting/connection/${connectionId}/accountingConfiguration'
  static saveAccountingConfigurationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name InitiatePlatformConnectionCheck
   * @request POST:/api/v1/organisation-accounting/connection/check
   */
  initiatePlatformConnectionCheck = (
    data: InitiateCheckConnectionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/connection/check`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static initiatePlatformConnectionCheckPath = '/v1/organisation-accounting/connection/check'
  static initiatePlatformConnectionCheckMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name Authorize1
   * @request POST:/api/v1/organisation-accounting/authorize
   */
  authorize = (data: AuthorizeOrganisationRequest, params: RequestParams = {}) =>
    this.http.request<AccountingConnectionDto, any>({
      path: `/v1/organisation-accounting/authorize`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static authorizePath = '/v1/organisation-accounting/authorize'
  static authorizeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAccountingIntegrationsEnabledFeaturesForOrganisation
   * @request GET:/api/v1/organisation-accounting/integrations/features
   */
  getAccountingIntegrationsEnabledFeaturesForOrganisation = (params: RequestParams = {}) =>
    this.http.request<Record<string, boolean>, any>({
      path: `/v1/organisation-accounting/integrations/features`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingIntegrationsEnabledFeaturesForOrganisationPath =
    '/v1/organisation-accounting/integrations/features'
  static getAccountingIntegrationsEnabledFeaturesForOrganisationMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetBatchExportStatus
   * @request GET:/api/v1/organisation-accounting/export/batch-exports/{batchExportId}/status
   */
  getBatchExportStatus = (batchExportId: string, params: RequestParams = {}) =>
    this.http.request<BatchExportStatusResponse, any>({
      path: `/v1/organisation-accounting/export/batch-exports/${batchExportId}/status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBatchExportStatusPath =
    '/v1/organisation-accounting/export/batch-exports/${batchExportId}/status'
  static getBatchExportStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetPlatformSyncData
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/syncInfo
   */
  getPlatformSyncData = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<PlatformSyncDataDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/syncInfo`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPlatformSyncDataPath = '/v1/organisation-accounting/connection/${connectionId}/syncInfo'
  static getPlatformSyncDataMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetSupplierAccountsByNamePrefix
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/supplierAccounts
   */
  getSupplierAccountsByNamePrefix = (
    { connectionId, ...query }: GetSupplierAccountsByNamePrefixParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PagedResponseSupplierAccountDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/supplierAccounts`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSupplierAccountsByNamePrefixPath =
    '/v1/organisation-accounting/connection/${connectionId}/supplierAccounts'
  static getSupplierAccountsByNamePrefixMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAvailablePlatformOrganisations
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/platformOrganisations
   */
  getAvailablePlatformOrganisations = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<PagedResponsePlatformOrganisationDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/platformOrganisations`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailablePlatformOrganisationsPath =
    '/v1/organisation-accounting/connection/${connectionId}/platformOrganisations'
  static getAvailablePlatformOrganisationsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name FindPlatformDimensionByNamePrefix
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/platformDimensions
   */
  findPlatformDimensionByNamePrefix = (
    { connectionId, ...query }: FindPlatformDimensionByNamePrefixParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PagedResponsePlatformDimensionDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/platformDimensions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findPlatformDimensionByNamePrefixPath =
    '/v1/organisation-accounting/connection/${connectionId}/platformDimensions'
  static findPlatformDimensionByNamePrefixMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAvailablePlatformDimensions
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/platform-dimensions/available
   */
  getAvailablePlatformDimensions = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<PlatformDimensionDto[], any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/platform-dimensions/available`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAvailablePlatformDimensionsPath =
    '/v1/organisation-accounting/connection/${connectionId}/platform-dimensions/available'
  static getAvailablePlatformDimensionsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetFileCabinets
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/file-cabinets
   */
  getFileCabinets = (
    { connectionId, ...query }: GetFileCabinetsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PagedResponsePlatformFileCabinetDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/file-cabinets`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getFileCabinetsPath =
    '/v1/organisation-accounting/connection/${connectionId}/file-cabinets'
  static getFileCabinetsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAccountingYearDetail
   * @request GET:/api/v1/organisation-accounting/connection/{connectionId}/accounting-year-detail
   */
  getAccountingYearDetail = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<PagedResponsePlatformAccountingYearDetailDto, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}/accounting-year-detail`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingYearDetailPath =
    '/v1/organisation-accounting/connection/${connectionId}/accounting-year-detail'
  static getAccountingYearDetailMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetConnectionStatus
   * @request GET:/api/v1/organisation-accounting/connection/status
   */
  getConnectionStatus = (params: RequestParams = {}) =>
    this.http.request<AccountingIntegrationDetailsDto, any>({
      path: `/v1/organisation-accounting/connection/status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getConnectionStatusPath = '/v1/organisation-accounting/connection/status'
  static getConnectionStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetCurrentDmsConnection
   * @request GET:/api/v1/organisation-accounting/connection/dms-connection
   */
  getCurrentDmsConnection = (params: RequestParams = {}) =>
    this.http.request<DmsConnectionDto, any>({
      path: `/v1/organisation-accounting/connection/dms-connection`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCurrentDmsConnectionPath = '/v1/organisation-accounting/connection/dms-connection'
  static getCurrentDmsConnectionMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAllAvailableAccountingPlatforms
   * @request GET:/api/v1/organisation-accounting/connection/available-platforms
   */
  getAllAvailableAccountingPlatforms = (params: RequestParams = {}) =>
    this.http.request<AvailablePlatform[], any>({
      path: `/v1/organisation-accounting/connection/available-platforms`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllAvailableAccountingPlatformsPath =
    '/v1/organisation-accounting/connection/available-platforms'
  static getAllAvailableAccountingPlatformsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAllAvailableDmsPlatforms
   * @request GET:/api/v1/organisation-accounting/connection/available-dms-platforms
   */
  getAllAvailableDmsPlatforms = (
    query: GetAllAvailableDmsPlatformsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<AvailableDMSPlatform[], any>({
      path: `/v1/organisation-accounting/connection/available-dms-platforms`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllAvailableDmsPlatformsPath =
    '/v1/organisation-accounting/connection/available-dms-platforms'
  static getAllAvailableDmsPlatformsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name TryFindLatestPlatformConnectionCheck
   * @request GET:/api/v1/organisation-accounting/connection-checks/latest
   */
  tryFindLatestPlatformConnectionCheck = (params: RequestParams = {}) =>
    this.http.request<PlatformConnectionCheckDto, any>({
      path: `/v1/organisation-accounting/connection-checks/latest`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static tryFindLatestPlatformConnectionCheckPath =
    '/v1/organisation-accounting/connection-checks/latest'
  static tryFindLatestPlatformConnectionCheckMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name GetAccountingConfigVisibleFields
   * @request GET:/api/v1/organisation-accounting/accounting-configuration/visible-fields
   */
  getAccountingConfigVisibleFields = (params: RequestParams = {}) =>
    this.http.request<AccountingConfigField[], any>({
      path: `/v1/organisation-accounting/accounting-configuration/visible-fields`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAccountingConfigVisibleFieldsPath =
    '/v1/organisation-accounting/accounting-configuration/visible-fields'
  static getAccountingConfigVisibleFieldsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-accounting-controller
   * @name Disconnect1
   * @request DELETE:/api/v1/organisation-accounting/connection/{connectionId}
   */
  disconnect = (connectionId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation-accounting/connection/${connectionId}`,
      method: 'DELETE',
      ...params,
    })

  static disconnectPath = '/v1/organisation-accounting/connection/${connectionId}'
  static disconnectMethod = 'DELETE'
}
